var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--full-page"},[_c('top-bar',{staticClass:"absolute"}),_c('router-view'),_c('vue-fab',{attrs:{"size":"big","mainBtnColor":'#ff0000',"icon":'sms',"menu":[]},on:{"clickMainBtn":_vm.sosWhatsApp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }